import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NbButtonModule, NbIconModule } from '@nebular/theme';
import { Observable, map } from 'rxjs';
import { ShoppingCart } from 'shared';
import { ShopService } from '../../../../shop/shop.service';

interface NativeCartView {
  cart: ShoppingCart;
  subtotal: number;
}

@Component({
  selector: 'app-native-tab',
  standalone: true,
  imports: [CommonModule, RouterLink, NbButtonModule, NbIconModule],
  templateUrl: './native-tab.component.html',
  styleUrl: './native-tab.component.scss'
})
export class NativeTabComponent {
  readonly view$: Observable<NativeCartView | null>;

  constructor(private readonly shop: ShopService) {
    this.view$ = this.shop.activeCart$().pipe(
      map((cart: ShoppingCart | null | undefined) => {
        if (!cart || !cart.items?.length) return null;
        const subtotal = cart.items.reduce(
          (sum, item) => sum + (item.price_data?.unit_amount ?? 0) * (item.quantity ?? 0),
          0
        );
        return { cart, subtotal };
      })
    );
  }
}
